import React from "react";
import { useTranslation } from "react-i18next";
import { LIFECYCLE_STATUSES } from "../../lib/platformValidation";

/**
 * One organization lifecycle state, rendered as a colour-coded badge.
 *
 * An unknown value degrades to a neutral "unknown" badge instead of printing an
 * internal label: the console must never invent a state the database does not
 * have.
 */
export const PlatformLifecycleBadge = ({ status, testId }) => {
  const { t } = useTranslation();
  const known = LIFECYCLE_STATUSES.includes(status);
  const tone = known ? status : "unknown";

  return (
    <span className={`qw-life-badge qw-life-${tone}`} data-testid={testId} data-state={tone}>
      {known ? t(`platform.lifecycle_${status}`) : t("platform.lifecycle_unknown")}
    </span>
  );
};

export default PlatformLifecycleBadge;
